import * as types from './types'
import store from '@/store'
import SendBird from 'sendbird'

export default {
  strict: false,
  namespaced: true,
  sendbird: null,
  channel: null,
  channelSet: null,
  channelListQuery: null,
  memberCount: 0,
  memberList: [],
  /*
  Initialize and Connect
   */
  initSendBird: function (callback) {
    this.sendbird = new SendBird({
      appId: window.config.sendbirdToken
    })
  },
  connectChat: function (register, callback) {
    var self = this
    if (this.sendbird === undefined || this.sendbird === null) {
      this.initSendBird()
    }
    this.sendbird.connect(register.userId.trim(), (user, error) => {
      if (error) {
        console.error(error)
        return
      }
      this.sendbird.updateCurrentUserInfo(register.nickname.trim(), '', (response, error) => {
        if (error) {
          console.error(error)
        } else {
          callback(response)
        }
      })
      const channelHandler = new this.sendbird.ChannelHandler()
      channelHandler.onMessageReceived = function (channel, message) {
        console.log('Message Received', message)
        store.dispatch('chat/addMessageToList', message)
        if ('Notification' in window) {
          document.getElementById('notifierSound').play()
        }
      }
      channelHandler.onMessageUpdated = function (channel, message) {
        console.log('Message Updated', message)
      }
      channelHandler.onMessageDeleted = function (channel, messageId) {
        console.log('Message Deleted', messageId)
      }
      channelHandler.onChannelChanged = function (channel) {
        console.log('Channel Changed', channel)
        self.getTotalUnreadCount(counts => {
        })
        store.dispatch('serviceRequests/updateRequestUnread', { id: channel.name, count: channel.unreadMessageCount })
      }
      channelHandler.onTypingStatusUpdated = function (channel) {
        store.dispatch('chat/setTyping', channel)
      }
      channelHandler.onReadReceiptUpdated = function (channel) {
        console.log('Message Read')
      }
      channelHandler.onUserLeft = function (channel, user) {
        console.log('User Left', user)
      }
      channelHandler.onUserJoined = function (channel, user) {
        console.log('User Joined', user)
      }
      this.sendbird.addChannelHandler([types.GLOBAL_HANDLER], channelHandler)
    })
  },
  /*
  Channels
   */
  setChannel: function (channel) {
    this.channel = channel
  },
  getChannelInfo: function (channelUrl, callback) {
    this.sendbird.GroupChannel.getChannel(channelUrl, (channel, error) => {
      if (error) {
        console.error(error)
        callback(null, error)
      }
      callback(channel, null)
    })
  },
  getChannelUnreadCount: function (channel) {
    return channel.unreadMessageCount
  },
  /*
  Messages
   */
  getMessageList(channelSet, callback) {
    if (!channelSet.query) {
      channelSet.query = channelSet.channel.createPreviousMessageListQuery()
    }
    if (channelSet.query.hasMore && !channelSet.query.isLoading) {
      channelSet.query.load(types.GET_MESSAGE_LIMIT, false, function (messageList, error) {
        if (error) {
          console.error(error)
        }
        callback(messageList)
      })
    }
  },
  insertMessageInList: function (target, index, item) {
    return target.splice(index, 0, item)
  },
  getTotalUnreadCount: function (callback) {
    this.sendbird.getTotalUnreadMessageCount(unreadCount => {
      if (callback) {
        callback(unreadCount)
      }
    })
  },
  /*
  Users
   */
  getUserList: function (search, action) {
    const self = this
    var processUsers = function (data) {
      var query = []
      if (data !== undefined && data !== null) {
        data.forEach(function (item) {
          query.push({
            userId: item.email,
            nickname: item.firstName + ' ' + item.lastName,
            profileUrl: (item.profileUrl !== null) ? item.profileUrl : '',
            isOnline: item.isOnline
          })
        })
      }
      return query
    }
    if (!self.userListQuery) {
      var xmlHttp = new XMLHttpRequest()
      var url = this.api.url + 'chat/Users'
      if (search !== undefined && search !== null) {
        url += '?token=&pagesize=5&search=' + search
      } else {
        url += '?token=&pagesize=50'
      }
      xmlHttp.open('GET', url, true)
      xmlHttp.setRequestHeader('Authorization', this.api.token)
      xmlHttp.onload = function () {
        if (xmlHttp.readyState === 4) {
          if (xmlHttp.status === 200) {
            var data = JSON.parse(xmlHttp.responseText)
            if (data !== undefined && data !== null) {
              self.userListQuery = processUsers(data)
              self.userListQuery.isLoading = false
              self.userListQuery.limit = 50
              self.userListQuery.hasNext = false
              self.userListQuery.next = null
              action(self.userListQuery)
            }
          } else {
            console.error(xmlHttp.statusText)
          }
        }
      }
      xmlHttp.onerror = function (e) {
        console.error(xmlHttp.statusText)
      }
      xmlHttp.send(null)
    }
  },
  xssEscape: function (target) {
    if (typeof target === 'string') {
      return target
        .split('&')
        .join('&amp')
        .split('#')
        .join('&#35')
        .split('<')
        .join('&lt')
        .split('>')
        .join('&gt')
        .split('"')
        .join('&quot')
        .split("'")
        .join('&apos')
        .split('+')
        .join('&#43')
        .split('-')
        .join('&#45')
        .split('(')
        .join('&#40')
        .split(')')
        .join('&#41')
        .split('%')
        .join('&#37')
    } else {
      return target
    }
  },
  getMessageTime: function (message) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    var _getDay = val => {
      const day = parseInt(val)
      if (day === 1) {
        return day + 'st'
      } else if (day === 2) {
        return day + 'en'
      } else if (day === 3) {
        return day + 'rd'
      } else {
        return day + 'th'
      }
    }
    var _checkTime = val => {
      return +val < 10 ? '0' + val : val
    }
    if (message) {
      const LAST_MESSAGE_TODAY = 'today'
      const LAST_MESSAGE_YESTERDAY = 'yesterday'
      var _nowDate = new Date()
      var _date = new Date(message.createdAt)
      var _time = _checkTime(_date.getHours()) + ':' + _checkTime(_date.getMinutes())
      if (_nowDate.getDate() - _date.getDate() === 1) {
        return LAST_MESSAGE_YESTERDAY + ' at ' + _time
      } else if (
        _nowDate.getFullYear() === _date.getFullYear() &&
        _nowDate.getMonth() === _date.getMonth() &&
        _nowDate.getDate() === _date.getDate()
      ) {
        return LAST_MESSAGE_TODAY + ' at ' + _time
      } else {
        return months[_date.getMonth()] + ' ' + _getDay(_date.getDate()) + ' at ' + _time
      }
    }
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/sendbird.js